
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo-request",
      function () {
        return require("private-next-pages/demo-request.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo-request"])
      });
    }
  